export default __webpack_public_path__ + "static/210602_夏日活動強更預告_tc-4ff5696b6d41624545906b5e99ca748d.png";